import { Snackbar as MuiSnackbar, SnackbarOrigin } from '@mui/material';
import { Alert, AlertProps } from '@mui/material';
import { ReactNode } from 'react';

export function Snackbar({
  onClose,
  children,
  severity,
  anchorOrigin
}: {
  onClose(): void;
  children: ReactNode;
  severity: AlertProps['severity'];
  /** Where the snackbar shows. Left out, it takes Material UI's default: bottom centre. */
  anchorOrigin?: SnackbarOrigin;
}) {
  return (
    <MuiSnackbar open={true} autoHideDuration={6000} onClose={onClose} anchorOrigin={anchorOrigin}>
      <Alert severity={severity} variant="filled">
        <p style={{ margin: 0, height: '100%', display: 'flex', alignItems: 'center', fontSize: '14px' }}>{children}</p>
      </Alert>
    </MuiSnackbar>
  );
}
